import {
  ListRolesForAccountApiArg,
  useListRolesForAccountQuery,
} from "@generated";
import { RootState } from "@reducers/rootReducer";
import { useSelector } from "react-redux";
import type { Role } from "../types";

export interface HookArgs {
  page?: ListRolesForAccountApiArg["page"];
  filter?: ListRolesForAccountApiArg["filter"];
}

const useListRoles = ({ page, filter }: HookArgs) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { data, error, isLoading, refetch } =
    useListRolesForAccountQuery({
      slug: accountSlug,
      page,
      filter,
    });

  let roles: Role[] = [];
  let customError: string | null = null;
  let pageMeta = {
    recordCount: 0,
    pageCount: 0,
  };

  if (data?.data) {
    try {
      roles = data.data.map((role) => {
        if (!role.id) {
          throw new Error("Missing role id");
        }

        return {
          id: role.id,
          name: role.attributes?.name || "",
        };
      });

      if (!data.meta) {
        throw new Error("Missing data.meta");
      }

      if (!data.meta["record-count"]) {
        throw new Error('Missing data.meta["record-count"]');
      }

      if (!data.meta["page-count"]) {
        throw new Error('Missing data.meta["page-count"]');
      }
      pageMeta = {
        recordCount: data.meta["record-count"],
        pageCount: data.meta["page-count"],
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    roles,
    error: error || customError,
    isLoading,
    pageMeta,
    refetch,
  };
};

export default useListRoles;
